import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.adminUser';

const translations = {
    'adminUser': 'Admin felhasználók',
    'edit.title': 'Admin felhasználó szerkesztése',
    'create.title': 'Új admin felhasználó',
    'adminUserCreate': 'Új admin felhasználó',
    'id.title': 'ID',
    'ext_id.title': 'GRoby ID',
    'name.title': 'Név',
    'email.title': 'Email',
    'telephone.title': 'Telefon',
    'permissions.title': 'Jogosultságok',
    'ip_address.title': 'IP cím',
    'is_admin.title': 'Admin?',
    'last_login.title': 'Utolsó bejelentkezés dátuma',

    'grantAdmin.label': 'Legyen admin',
    'revokeAdmin.label': 'Ne legyen admin',

    'permissions.LOGIN_AS_USER': 'Belépés a felhasználó nevében',
    'permissions.MANAGE_ADMINS': 'Adminisztrátorok kezelése',
    'permissions.MANAGE_BANNERS': 'Bannerek kezelése',
    'permissions.MANAGE_CMS': 'Cikkek',
    'permissions.MANAGE_COUPONS': 'Kuponok',
    'permissions.MANAGE_DASHBOARD': 'Dashboard',
    'permissions.MANAGE_ORDERS': 'Megrendelések',
    'permissions.MANAGE_PAYMENTS': 'Fizetési módok',
    'permissions.MANAGE_PRODUCTS': 'Termékek',
    'permissions.MANAGE_PRODUCT_ATTRIBUTES': 'Termékparaméterek',
    'permissions.MANAGE_PRODUCT_CATEGORIES': 'Termékkategóriák',
    'permissions.MANAGE_PRODUCT_VOTES': 'Szavazatok',
    'permissions.MANAGE_SHIPPING': 'Szállítási módok',
    'permissions.MANAGE_TIMETABLES': 'Idősávok kezelése',
    'permissions.MANAGE_URL_ALIASES': 'Átirányítások',
    'permissions.MANAGE_USERS': 'Felhasználók',
    'permissions.MANAGE_USER_DISCOUNTS': 'Felhasználó kedvezmények',
    'permissions.MANAGE_DONATIONS': 'Adományozások',
    'permissions.MANAGE_PRODUCT_LIST_ADS': 'Terméklista bannerek',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/AdminUser/lang/hu.ts